import { omitBy } from "lodash";
import routes from "../../capiRoutes";
import raw from "../../rawClients/rawCapiClient";
import rfisSettingsSerializer from "../../serializers/rfisSettings";
import rfiSerializer from "../../serializers/rfi";
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const UNSET = "__UNSET__";
const omitUnset = attributes => omitBy(attributes, value => value === UNSET);
const REFERENCE_TYPES = {
  PHOTO: "photo",
  ATTACHMENT: "attachment",
  SNAPSHOT: "snapshot",
  DOCUMENT: "document",
};
export default {
  getAllInProject(projectUid, params) {
    return raw.getAll(routes.rfis2.allInProject(projectUid), params);
  },
  getAllStatusesInProject(projectUid) {
    return raw.getAll(routes.rfis2.statusesInProject(projectUid));
  },
  getSettingsInProject(projectUid) {
    return raw
      .get(routes.rfis2.settingsInProject(projectUid))
      .then(data => rfisSettingsSerializer.fromServer(data));
  },
  createInProject: (
    projectUid,
    {
      managers = UNSET,
      reviewers = UNSET,
      dueDate: answerDueDate = UNSET,
      question = UNSET,
      title = UNSET,
      statusUid = UNSET,
      references = [],
      number = UNSET,
    }
  ) =>
    raw
      .post(routes.rfis2.allInProject(projectUid), {
        ...rfiSerializer.toServer(
          omitUnset({
            managers,
            reviewers,
            question,
            title,
            statusUid,
            answerDueDate,
            number,
          })
        ),
        references_added: references.map(({ type, uid }) => ({
          type:
            type === REFERENCE_TYPES.ATTACHMENT
              ? REFERENCE_TYPES.DOCUMENT
              : type,
          uid,
        })),
        timezone,
      })
      .then(rfiSerializer.fromServer),
};
